var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            {
              staticClass: "bg-white ms-3",
              class: { "me-3": _vm.mobile },
              attrs: { lg: "8" },
            },
            [
              _c(
                "div",
                { staticClass: "question-menu mb-3 d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { lg: "10" } },
                    [
                      _c(
                        "v-tabs",
                        [
                          _c(
                            "v-tab",
                            { attrs: { to: "/classroom/my-questions" } },
                            [_vm._v("マイ質問")]
                          ),
                          _vm._v(" "),
                          _c("v-tab", { attrs: { to: "questions" } }, [
                            _vm._v("みんなの質問"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { attrs: { to: "/classroom/my-answer-questions" } },
                            [_vm._v("アンサーした質問")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mobile
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "float-right mt-4",
                          attrs: { color: "white" },
                          on: {
                            click: function ($event) {
                              _vm.showSideBar = true
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(
                              "\n            mdi-chevron-right-circle-outline\n          "
                            ),
                          ]),
                          _vm._v("\n          カテゴリ\n        "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.mobile
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-end text-end p-0 pe-2",
                          attrs: { lg: "2" },
                        },
                        [_c("UserQuestionDialog")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("v-combobox", {
                            attrs: {
                              items: _vm.items,
                              "search-input": _vm.search,
                              placeholder: "入力してください",
                              "prepend-icon": "mdi-database-search",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.search = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.search = $event
                              },
                            },
                            model: {
                              value: _vm.model,
                              callback: function ($$v) {
                                _vm.model = $$v
                              },
                              expression: "model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "me-2 mt-7 search-test",
                          on: { click: _vm.clearSearch },
                        },
                        [_vm._v(" クリア ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _vm._l(Array.from(Array(10).keys()), function (item, index) {
                    return _c("v-skeleton-loader", {
                      key: index,
                      ref: "skeleton",
                      refInFor: true,
                      staticClass: "mx-auto",
                      attrs: { type: "list-item-avatar-three-line" },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentCourse
                ? [
                    _c("h3", { staticClass: "ms-5" }, [
                      _vm._v(
                        _vm._s(_vm.currentCourse.name) +
                          " (" +
                          _vm._s(_vm.currentCourse.questionCount) +
                          ")"
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("QuestionList", { attrs: { questions: _vm.questions } }),
              _vm._v(" "),
              _vm.questions.length > 0 && _vm.pagination.totalPages > 1
                ? _c("v-pagination", {
                    staticClass: "mt-4 mb-5",
                    class: { "pb-10": _vm.mobile },
                    attrs: { length: _vm.pagination.totalPages },
                    on: { input: _vm.selectPage },
                    model: {
                      value: _vm.pagination.page,
                      callback: function ($$v) {
                        _vm.$set(_vm.pagination, "page", $$v)
                      },
                      expression: "pagination.page",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobile ? _c("div", { style: { height: "100px" } }) : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          !_vm.mobile
            ? [
                _vm.sideBarData.courses.length > 0
                  ? _c(
                      "v-col",
                      { staticClass: "bg-white ms-3", attrs: { lg: "3" } },
                      [
                        _c("h2", [_vm._v("講座別質問")]),
                        _vm._v(" "),
                        _c("v-divider"),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          [
                            _c(
                              "v-card-text",
                              [
                                _c("v-combobox", {
                                  attrs: {
                                    items: _vm.courseItems,
                                    "search-input": _vm.searchCourse,
                                    placeholder: "入力してください",
                                    "prepend-icon": "mdi-database-search",
                                  },
                                  on: {
                                    "update:searchInput": function ($event) {
                                      _vm.searchCourse = $event
                                    },
                                    "update:search-input": function ($event) {
                                      _vm.searchCourse = $event
                                    },
                                  },
                                  model: {
                                    value: _vm.modelCourse,
                                    callback: function ($$v) {
                                      _vm.modelCourse = $$v
                                    },
                                    expression: "modelCourse",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          _vm._l(_vm.showCourses, function (course) {
                            return _c(
                              "v-list-item",
                              {
                                key: course.id,
                                attrs: {
                                  to:
                                    "/classroom/questions?course_id=" +
                                    course.id,
                                  exact: course.id,
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "me-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "question-box" },
                                      [
                                        _c("v-img", {
                                          attrs: { src: course.image },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", {
                                      domProps: {
                                        textContent: _vm._s(course.name),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("v-list-item-subtitle", [
                                      _c("span", { staticClass: "me-2" }, [
                                        _vm._v(
                                          "質問数 " +
                                            _vm._s(course.questionCount)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "me-2" }, [
                                        _vm._v(
                                          "解決数 " + _vm._s(course.answerCount)
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c(
                  "v-navigation-drawer",
                  {
                    staticClass: "bg-white",
                    attrs: { absolute: "", temporary: "", right: "" },
                    model: {
                      value: _vm.showSideBar,
                      callback: function ($$v) {
                        _vm.showSideBar = $$v
                      },
                      expression: "showSideBar",
                    },
                  },
                  [
                    _vm.sideBarData.courses.length > 0
                      ? _c(
                          "v-col",
                          { staticClass: "bg-white ms-3" },
                          [
                            _c("h2", [_vm._v("講座別質問")]),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("v-combobox", {
                                      attrs: {
                                        items: _vm.courseItems,
                                        "search-input": _vm.searchCourse,
                                        placeholder: "入力してください",
                                        "prepend-icon": "mdi-database-search",
                                      },
                                      on: {
                                        "update:searchInput": function (
                                          $event
                                        ) {
                                          _vm.searchCourse = $event
                                        },
                                        "update:search-input": function (
                                          $event
                                        ) {
                                          _vm.searchCourse = $event
                                        },
                                      },
                                      model: {
                                        value: _vm.modelCourse,
                                        callback: function ($$v) {
                                          _vm.modelCourse = $$v
                                        },
                                        expression: "modelCourse",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list",
                              _vm._l(_vm.showCourses, function (course) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: course.id,
                                    attrs: {
                                      to:
                                        "/classroom/questions?course_id=" +
                                        course.id,
                                      exact: course.id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "me-4" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "question-box" },
                                          [
                                            _c("v-img", {
                                              attrs: { src: course.image },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          domProps: {
                                            textContent: _vm._s(course.name),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _c("span", { staticClass: "me-2" }, [
                                            _vm._v(
                                              "質問数 " +
                                                _vm._s(course.questionCount)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "me-2" }, [
                                            _vm._v(
                                              "解決数 " +
                                                _vm._s(course.answerCount)
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.mobile
        ? _c("v-footer", { attrs: { fixed: true } }, [
            _c(
              "div",
              {
                staticClass: "d-flex",
                attrs: { justify: "center", "no-gutters": "" },
              },
              [
                _c(
                  "v-col",
                  { staticClass: "text-center", attrs: { cols: "12" } },
                  [_c("UserQuestionDialog")],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }